import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Dummylayout from "../Dummylayout";
import BasicCard from "../BasicCard";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { baseURL } from "../../config";

function InitiatePerformance() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [rows, setRows] = useState([
    { id: 1, issue: "", correctiveAction: "" },
  ]);
  const [employee, setEmployee] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const [terms, setTerms] = useState([]);

  // const addRow = () => {
  //     if (rows.length < 5) {
  //         const newId = rows.length + 1;
  //         setRows([...rows, { id: newId, issue: '', correctiveAction: '' }]);
  //     }
  // };
  const addRow = () => {
    if (rows.length < 5) {
      const newId = rows.length + 1;
      setRows([...rows, { id: newId }]);
    }
  };

  const handleTermChange = (e) => {
    const { name, checked } = e.target;
    if (checked && name === "midYear") {
      setTerms({
        midYear: true,
        endOfYear: false,
      });
    } else if (checked && name === "endOfYear") {
      setTerms({
        midYear: false,
        endOfYear: true,
      });
    } else {
      setTerms({
        midYear: false,
        endOfYear: false,
      });
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setFormData(values);
    setShowModal(true); // Show the modal
  };

  const handleConfirm = async () => {
    try {
      const response = await fetch(`${baseURL}/addpip`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/piptable");
        }, 3000);
        // window.location.href = "/piptable";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error(error);
    }
    setShowModal(false); // Hide the modal
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getemployeedetails?id=` + id
        );
        const data = response.data;
        let arrEmployee = data.employee;
        setEmployee(arrEmployee[0]);

        // fetchAppraisalTemplate(gradeid);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeData();
  }, []);

  return (
    <>
      <Dummylayout />
      <BasicCard>
        <div className="container">
          <h4 className="pb-3">PERFORMANCE IMPROVEMENT PLAN</h4>

          <Formik
            enableReinitialize={true}
            initialValues={{
              employeename: employee.FirstName || "",
              employeeid: employee.employeeid || "",
              issue1: "",
              action1: "",
              issue2: "",
              action2: "",
              issue3: "",
              action3: "",
              issue4: "",
              action4: "",
              issue5: "",
              action5: "",
              period: "",
            }}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div className="col-lg-12 p-2 mt-2">
                  <div className="row ">
                    <div className="col-4">
                      <span className="vfont fs-">Name</span>
                      <br></br>
                      <p className="bfont fs-5 fw-bold">
                        {employee.FirstName} {employee.LastName}
                      </p>
                      <Field
                        type="hidden"
                        name="employeename"
                        value={values.employeename}
                      />
                    </div>
                    <div className="col-4">
                      <span className="vfont fs">Employee ID</span>
                      <p className="bfont fs-5 fw-bold">
                        {" "}
                        {employee.employeeid}
                      </p>
                      <Field
                        type="hidden"
                        name="employeeid"
                        value={values.employeeid}
                      />
                    </div>
                    <div className="col-4">
                      <span className="vfont fs">
                        Appraisal period for PIP:
                      </span>
                      <p
                        className="fs-5 bluefont fw-bold"
                        id="currentyear"
                        name="period"
                        value="period"
                      >
                        {terms.midYear
                          ? `April ${new Date().getFullYear()}`
                          : ""}
                        {terms.endOfYear
                          ? `December ${new Date().getFullYear()}`
                          : ""}
                      </p>
                      <Field
                        type="hidden"
                        name="period"
                        value={
                          (values.period = terms.midYear
                            ? `April ${new Date().getFullYear()}`
                            : terms.endOfYear
                            ? `December ${new Date().getFullYear()}`
                            : "")
                        }
                      />
                    </div>

                    <div className="mt-3">
                      <h6>SELECT TERM</h6>
                      <div className="form-check">
                        <Field
                          className="form-check-input"
                          type="checkbox"
                          id="midYear"
                          name="midYear"
                          checked={terms.midYear}
                          onChange={handleTermChange}
                          value={terms.midYear}
                        />
                        <label className="form-check-label" htmlFor="midYear">
                          Mid Year
                        </label>
                      </div>
                      <div className="form-check">
                        <Field
                          className="form-check-input"
                          type="checkbox"
                          id="endOfYear"
                          name="endOfYear"
                          checked={terms.endOfYear}
                          onChange={handleTermChange}
                          value={terms.endOfYear}
                        />
                        <label className="form-check-label" htmlFor="endOfYear">
                          End of Year
                        </label>
                      </div>
                    </div>
                  </div>

                  {rows.map((row, index) => (
                    <div key={row.id} className="row">
                      <div className="col-lg-5 mt-3">
                        <label>Issue</label>
                        <Field
                          as="textarea"
                          className={`form-control h-75`}
                          placeholder=""
                          name={`issue${index + 1}`}
                          value={values[`issue${index + 1}`]}
                        />
                      </div>
                      <div className="col-lg-5 mt-3 ml-5">
                        <label>Corrective action</label>
                        <Field
                          as="textarea"
                          className={`form-control h-75`}
                          placeholder=""
                          name={`action${index + 1}`}
                          value={values[`action${index + 1}`]}
                        />
                      </div>
                    </div>
                  ))}

                  <Button
                    className="btn addqabtn btn-primary mt-3 p-2 text-decoration-none mt-4"
                    onClick={addRow}
                    disabled={rows.length >= 5}
                  >
                    Create Another +
                  </Button>
                </div>
                <div className="col-lg-11 text-end mt-5 pb-3">
                  <button
                    type="submit"
                    className="border-0 mt-3 p-1 savebtn fst-normal"
                  >
                    Save
                  </button>
                  <a href="/Skills" className="text-decoration-none ">
                    <Button type="button" className="btn cancelbtn ml-2">
                      Cancel
                    </Button>
                  </a>
                </div>
              </Form>
            )}
          </Formik>
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>CONFIRM CHANGES</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to save the changes?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button variant="primary" onClick={handleConfirm}>
                Save changes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <div>
          <ToastContainer position="bottom-end" className="p-3">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={3000}
              autohide
              className="bg-success text-white"
            >
              <Toast.Header>
                <span className="me-2">✔️</span> {/* Unicode tick mark */}
                <strong className="me-auto">Notification</strong>
              </Toast.Header>
              <Toast.Body>Success!, data updated successfully!</Toast.Body>
            </Toast>
          </ToastContainer>
        </div>
      </BasicCard>
    </>
  );
}

export default InitiatePerformance;
